import { Field, MatterFormsSource } from '@models/matter-forms';

export class Create {
	static readonly type = '[matter-form-data-v2] set';

	constructor(
		public payload: {
			id: string;
			matterId: string;
			fields: { [key: string]: Field };
			sourceId: string;
			source: MatterFormsSource;
			url: string;
			barcodeUrl: string;
		},
	) {}
}

export class SetField {
	static readonly type = '[matter-form-data-v2] set field';
	constructor(public payload: { id: string; field: string; value: unknown }) {}
}
